

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import { UserColumn } from '../../models/user-info.model';

export interface SaveColumnPayload {
  userColumns: UserColumn[];
}

export interface GetColumnOrderResponse {
  userColumns: UserColumn[];
}

@Injectable({
  providedIn: 'root'
})
export class SaveColumnsService {

  private apiUrl = environment.backendApiConfiguration.api_url ;
  
  constructor(private http: HttpClient) { }

  saveColumnOrderLandingPage(payload: SaveColumnPayload): Observable<any> {
    return this.http.post(`${this.apiUrl}users/saveFilters`, payload);
  }

  getColumnOrderLandingPage(): Observable<GetColumnOrderResponse> {
    return this.http.get<GetColumnOrderResponse>(`${this.apiUrl}users/getFilters`);
  }
}
